var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.155,
    cy: 7.655,
    fill: "#335280",
    r: 7.655
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.858 14.87l3.56-3.56L25.5 21.395l-3.559 3.559z",
    fill: "#60B6B1"
  })));
}
export default SvgReferences;